import { render } from "./TableCustomers.vue?vue&type=template&id=7ab886ab"
import script from "./TableCustomers.vue?vue&type=script&lang=js"
export * from "./TableCustomers.vue?vue&type=script&lang=js"
script.render = render

export default script